// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';

import Vue from 'vue'
import App from './App'
import router from './router'
import directive from './directive'
import store from './store'

import 'mint-ui/lib/style.css'
import Mint from 'mint-ui';
Vue.use(Mint);
Vue.use(directive)

import axios from 'axios'
Vue.prototype.$http = axios;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  }
})

if (module.hot) {
  module.hot.accept();
}


// WEBPACK FOOTER //
// ./src/main.js